export enum WidthCategory {
  large = 'large',
  medium = 'medium',
  small = 'small',
}
